export default function Travel(){
    return(
        <section>
            <h1>TRAVEL PAGE</h1>
        </section>
    )
}